import { render } from "./Or_insurance.vue?vue&type=template&id=f3830eac&scoped=true&ts=true"
import script from "./Or_insurance.vue?vue&type=script&lang=ts"
export * from "./Or_insurance.vue?vue&type=script&lang=ts"

import "./Or_insurance.vue?vue&type=style&index=0&id=f3830eac&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3830eac"]])

export default __exports__